export default interface GroupCriteria {
    groupIds ?: number[]
    customerIds ?: number[]
    includeDetails ?: boolean
}

export function getQueryFromGroupCriteria(criteria: GroupCriteria | void): URLSearchParams | undefined {
    if (!criteria)
        return undefined;

    let params = new URLSearchParams();

    if (criteria.groupIds && criteria.groupIds.length > 0){
        for(const groupId of criteria.groupIds) {
            params.append("groupIds", `${groupId}`);
        }
    }
    if (criteria.customerIds && criteria.customerIds.length > 0){
        for(const customerIds of criteria.customerIds) {
            params.append("customerIds", `${customerIds}`);
        }
    }
    if (criteria.includeDetails) {
        params.append("includeDetails", `${criteria.includeDetails}`);
    }

    return params;
}